import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Title } from '../styled'
import { Contents } from '../layouts/styled'
import { TaskForm } from '../components'

const TaskEditScreen = ({ setItems }) => {
  const { t } = useTranslation()

  return (
    <Contents>
      <Title>{t('task.edit.title')}</Title>
      <TaskForm t={t} setItems={setItems} />
    </Contents>
  )
}

export default TaskEditScreen

TaskEditScreen.propTypes = {
  setItems: PropTypes.func
}
